// src/utils.ts
function getDefaultErrorMessage(hook, provider) {
  return `${hook} must be used within ${provider}`;
}

export {
  getDefaultErrorMessage
};
